import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';

import { SkyAvatarAdapterService } from './avatar-adapter.service';
import { SkyAvatarSrc } from './avatar-src';


export class SkyAvatarInnerComponent implements AfterViewInit, OnDestroy {
  public get src(): SkyAvatarSrc {
    return this._src;
  }

  
  public set src(value: SkyAvatarSrc) {
    this._src = value;
    this.updateImage();
  }

  public get name(): string {
    return this._name;
  }

  
  public set name(value: string) {
    this._name = value;
  }

  private viewInitialized: boolean;

  private _src: SkyAvatarSrc;

  private _name: string;

  constructor(
    private elementRef: ElementRef,
    private adapter: SkyAvatarAdapterService
  ) { }

  public get initials(): string {
    let initials: string;

    if (this.name) {
      let nameSplit = this.name.split(' ');
      initials = getInitial(nameSplit[0]);

      if (nameSplit.length > 1) {
        initials += getInitial(nameSplit[nameSplit.length - 1]);
      }
    }

    return initials;
  }

  public get colorIndex(): number {
    let name = this.name;
    let colorIndex: number;

    if (name) {
        // Generate a unique-ish color based on the record name.  This is deterministic
        // so that a given name will always generate the same color.
        let seed = name.charCodeAt(0) + name.charCodeAt(name.length - 1) + name.length;
        colorIndex = Math.abs(seed % 6);
    } else {
        colorIndex = 0;
    }

    return colorIndex;
  }

  public ngAfterViewInit() {
    this.viewInitialized = true;
    this.updateImage();
  }

  public ngOnDestroy() {
    this.adapter.destroy();
  }

  private updateImage() {
    if (this.viewInitialized) {
      this.adapter.updateImage(this.elementRef, this.src);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-avatar-inner',
  template: `<div class="sky-avatar-wrapper">
  <div class="sky-avatar-image" [hidden]="!src"></div>
  <div
    class="sky-avatar-initials"
    [ngClass]="'sky-palette-multi-' + (colorIndex + 1)"
    [hidden]="src || !name"
    >
    <div class="sky-avatar-initials-inner">
      {{initials}}
    </div>
  </div>
</div>
`,
  styles: [`.sky-avatar-wrapper {
  height: 104px;
  width: 104px;
  border: solid 2px transparent;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  top: -2px;
  left: -2px;
}

.sky-avatar-image,
.sky-avatar-initials {
  height: 100px;
  width: 100px;
  background-position: 50%;
  background-size: cover;
  /* this removes the "ghost margin" from the bottom of the canvas element that would otherwise be imposed by line height rules for inline elements */
  display: flex;
  align-items: center;
  justify-content: center;
}

.sky-avatar-initials-inner {
  color: #fff;
  cursor: default;
  font-size: 50px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
`],
  providers: [SkyAvatarAdapterService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: SkyAvatarAdapterService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'src': [{ type: Input },],
'name': [{ type: Input },],
};
}

function getInitial(name: string): string {
  return name.charAt(0).toUpperCase();
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
